export default __webpack_public_path__ + "static/media/PlasmaTemplateImg.5ac5e490.jpg";